/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// mantine
import {
	Alert,
	Box,
	Text,
	CopyButton,
	ActionIcon,
	Tooltip,
	rem,
} from '@mantine/core';

// icons
import { IconCopy, IconCheck } from '@tabler/icons-react';

// styles
import classes from './AlertAccessToken.module.css';

// components
import { PasswordInput } from '@components/atoms/PasswordInput';

// i18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const CopyButtonNative = (props: {
	valueToCopy: string;
}) => {
	/* ******************************** I18N ******************************* */
	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */
	return (
		<CopyButton value={props.valueToCopy} timeout={2000}>
			{({ copied, copy }) => (
				<Tooltip
					label={
						copied ? t('global.copied') : t('global.copy')
					}
					withArrow
					position="right"
				>
					<ActionIcon
						variant="filled"
						color={'success'}
						onClick={copy}
						size={'lg'}
					>
						{copied ? (
							<IconCheck style={{ width: rem(16) }} />
						) : (
							<IconCopy style={{ width: rem(16) }} />
						)}
					</ActionIcon>
				</Tooltip>
			)}
		</CopyButton>
	);
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const AlertAccessToken = (props: {
	accessToken?: string;
	handleclose?: () => void;
}) => {
	/* ******************************** I18N ******************************* */
	const { t } = useTranslation();

	const icon = <IconCheck />;

	/* ******************************** RENDERING ******************************* */
	return (
		<Alert
			color="success"
			title={t('apiTokens.yourNewAccessToken')}
			icon={icon}
			withCloseButton
			onClose={props.handleclose}
		>
			<Box className={classes.container}>
				<Box className={classes.containerPasswordInput}>
					<PasswordInput
						size="sm"
						radius="8.29px"
						placeholder={'**'}
						readOnly
						value={props.accessToken}
					/>
				</Box>
				<Box
					style={{
						alignSelf: 'center',
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<CopyButtonNative
						valueToCopy={
							props.accessToken ? props.accessToken : ''
						}
					/>
				</Box>
			</Box>
			<Text className={classes.description}>
				{t('apiTokens.tokenCreationDescription')}
			</Text>
		</Alert>
	);
};
